import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type FormSectionProps = {
  title?: string;
  children: React.ReactNode;
};

const SectionWrapper = styled.div``;

const SectionContent = styled.div`
  border: 1px solid ${cbSemanticCssVars.borderPrimary};
  border-radius: 16px;
`;

const SectionTitle = styled(T.Title1)`
  display: block;
  font-weight: 700;
  margin-block-end: 16px;
  width: 100%;
`;

const SectionContentWrapper = styled.div`
  padding: 16px;
`;

const FormSection = ({ title, children }: FormSectionProps) => (
  <SectionWrapper>
    {title && <SectionTitle>{title}</SectionTitle>}

    <SectionContent>
      <SectionContentWrapper>{children}</SectionContentWrapper>
    </SectionContent>
  </SectionWrapper>
);

export default FormSection;
